module.exports = function() {
    $(document).ready(function () {
        var listen = function () {
            $('#scf-form-contactForm input, #scf-form-contactForm textarea').change(function () {
                var group = $(this).closest('.form-group');
                group.removeClass('has-error');
                group.find('.invalid-feedback').hide();
            });
        }
        listen();
        $('#scf-form-contactForm').bind("DOMSubtreeModified", function () {
            $('#scf-form-contactForm input, #scf-form-contactForm textarea').off();
            listen();
        });
    })
}